import { cx } from '@flowus/common/cx';
import { CollectionSchemaType } from '@next-space/fe-api-idl';
import type { FC } from 'react';
import { useState } from 'react';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { useBitable } from 'src/bitable/context';
import { Button } from 'src/common/components/button';
import { Icon } from 'src/common/components/icon';
import { useUpdatePropertySchema } from 'src/hooks/block/use-update-property-schema';
import { getState } from 'src/redux/store';
import { v4 } from 'uuid';

interface SelectRelationTypeProps {
  propertyId: string;
  closeSelf: () => void;
}
export const SelectRelationType: FC<SelectRelationTypeProps> = ({ propertyId, closeSelf }) => {
  const { t } = useAppTranslation();
  const { collectionId } = useBitable();
  const [isSync, setIsSync] = useState(false);
  const updatePropertySchema = useUpdatePropertySchema();

  return (
    <div className="next-modal w-[450px] p-2 pb-7">
      <div
        className={cx('flex rounded p-3 cursor-pointer')}
        style={{
          background: isSync ? 'rgba(0,0,0,0.06)' : undefined,
        }}
        onClick={() => setIsSync(true)}
      >
        <Icon
          size="normal"
          name={__BUILD_IN__ ? 'MIcBinRelationSync' : 'MIcRelationSync'}
          className="!w-[150px] !h-[100px]"
        />
        <div className="ml-4 flex flex-col justify-center">
          <p className={cx('text-t2', isSync && 'font-medium')}>
            {t('bitable.table_view.widgets.select_relation_type.sync_title')}
          </p>
          <p className="mt-1 text-t4">
            <span className="font-bold">
              {t('bitable.table_view.widgets.select_relation_type.sync_desc_bold')}
            </span>
            {t('bitable.table_view.widgets.select_relation_type.sync_desc')}
          </p>
        </div>
      </div>

      <div
        className={cx('flex mt-1.5 rounded  p-3 cursor-pointer', !isSync && 'font-medium')}
        style={{
          background: !isSync ? 'rgba(0,0,0,0.06)' : undefined,
        }}
        onClick={() => setIsSync(false)}
      >
        <Icon
          size="normal"
          name={__BUILD_IN__ ? 'MIcBinRelationUnsync' : 'MIcRelationUnsync'}
          className="!w-[150px] !h-[100px]"
        />
        <div className="ml-4 flex flex-col justify-center">
          <p className={cx('text-t2', !isSync && 'font-medium')}>
            {t('bitable.table_view.widgets.select_relation_type.unsync_title')}
          </p>
          <p className="mt-1 text-t4">
            <span className="font-bold">
              {t('bitable.table_view.widgets.select_relation_type.unsync_desc_bold')}
            </span>
            {t('bitable.table_view.widgets.select_relation_type.unsync_desc')}
          </p>
        </div>
      </div>

      <Button
        className="h-8 text-t2-medium mt-5"
        size="auto"
        colorType="active"
        onClick={() => {
          let newPropertyId = propertyId;
          if (isSync) {
            newPropertyId = v4();
          }

          const { blocks } = getState();
          closeSelf();
          updatePropertySchema(collectionId, propertyId, {
            type: CollectionSchemaType.RELATION,
            collectionId,
            spaceId: blocks[collectionId]?.spaceId,
            pairProperty: newPropertyId,
          });
        }}
      >
        {t('bitable.table_view.widgets.select_relation_type.create_relation')}
      </Button>
    </div>
  );
};
